import React, { PureComponent } from 'react';

import { createContainer } from '@dbk-legacy/muster/react';

import BlurModal from '../../common/blur-modal';

import styles from './rsa-modal.styles';

import RSA from './rsa';
import RSAPIN from './rsa-pin';

class RsaModal extends PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {rsa} = this.props;

    console.log(this.props);
    this.onRsaDone = this.onRsaDone.bind(this);
  }

  onRsaDone() {
     const {rsa} = this.props;
     this.props.rsa.onHideRsa();
  }

  render() {
    const {
        title,
        doneLabel,
      } = this.props;

    return (
      <BlurModal
        title={title}
        visible={this.props.rsa.rsaVisible}
        onDone={this.onRsaDone}
        doneLabel={doneLabel}
      >
          {!this.props.rsa.rsapinVisible &&  <RSA/> }

          {this.props.rsa.rsapinVisible && <RSAPIN/>}
      </BlurModal>

    );
  }


}

export default createContainer({
  $queries: {
    rsa: {
       rsaAuthorised: true,
       rsaVisible: true,
       rsapinVisible: true,
       onChangePage: {$call: 'changePage'},
       onHideRsa: {$call: 'hideRsa'},
      },
    }
})(RsaModal);
